import { LeaderboardSection } from '@/components/dashboard/LeaderboardSection'

export function LeaderboardPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <LeaderboardSection />
    </div>
  )
}
